import { EnvironmentService } from './environment.service';

export function EnvironmentFactory(environmentService: EnvironmentService) {
  return () => environmentService.getConfig();
}
